/* eslint-disable */
import { SaveCancelFooter } from '@/components/molecules'
import { ROUTES } from '@/utils/constants/routesConstants'
import { ReviewAccordion, ReviewActionHeader } from '@/containers'
import { useAppDispatch, useAppSelector } from '@/store'
import { PageHeader } from '@pepsico-ds/ui'
import { useCallback, useEffect, useState, useMemo } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { setLanguages, setToastNotifications } from '@/store/slices/commonSlice'
import { ProgressIndicator, Breadcrumb, Modal, ErrorBoundary, TableSkeletonLoader } from '@/components/atoms'
import { useErrorHandler } from '@/hooks/useErrorHandler'
import { getSalesTargetData, getSalesTargetsReporteDownload, putSalesTarget, patchSalesTarget} from '@/services/salesTargets'
import {  setSalesTarget, setSalesTargetFormData, setSelectedType, setInitialTargetName, setRuleSet, setTargetType, setPageActiveTab, setSalesTargetUuid, resetSalesTarget, addPreRequisiteParentTab, addPreRequisiteChildTab } from '@/store/slices/salesTargetSlice'
import { useParams } from 'react-router-dom'
import { getDateFromISOString } from '@/utils/commons'
import { MODAL_TYPE } from '@/utils/constants/globalStyle'
import { TARGET_TYPES, TARGET_TYPES_OPTIONS, IMAGETYPE, EARLY_PAYMENT_TYPES, DROP_SIZE_TYPES } from '@/utils/constants/saleTargetConstants'
import { getStepConfig, isCdaSuperTargetType } from '@/utils/salesTargetStepConfig'
import { downloadCSVFiles, getDateWithTimeString } from '@/helpers/shadcn/utils'
import { API_STATUS, Constants, STATUS_VALUES } from '@/utils/constants/commonConstants'
import { getDisplayContentLanguagesService } from '@/services/languageService'
import { useProductList } from '@/containers/ProductsContainer/SalesTargetProducts/useProductList'
import { deepMerge } from '@/helpers/deepMerge'
import enUS from '@/internationalization/i18n/en-us'
import { COUNTRY_CODES, COUNTRY_LANGUAGES_CODES } from '@/utils/constants/globalConstants'
import {useCategoryList} from '@/hooks/useCategoryList'
import { useSalesTargets } from '@/hooks/useSalesTargets'
import { buildSalesTargetDraftPayload, createSalesTargetRequestObject, getSalesTargetDate } from '@/pages/SalesTargetUtils'
import {logger} from '@/helpers/logger';
import { normalizeProductGtins } from '@/utils/productGroupQuantity'
export const SalesTargetReview = () => {
  const [isCancel, setIsCancel] = useState(false)
    const [loading, setLoading] = useState(false)
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const { handleApiError } = useErrorHandler()
  const [categoryList, setCategoryList] = useState([])
  const {fetchCategoryList} = useCategoryList(false)
  const salesTargetData = useAppSelector(state => state.salesTarget)
  const [isOpenStoreListModal, setOpenStoreListModal] = useState(false)
  const [isReadOnly, setIsReadOnly] = useState(false)
  const { productListData, isLoading: isProductListLoading } = useProductList({ isReviewPage: true })
  const countryCode = useAppSelector(state => state.countryCode)?.countryCode
  const countryName = enUS?.COUNTRIES[countryCode] || ''
  const {handleDraft, handlePublish, onTemplateUpdate} = useSalesTargets(false)
  const [isPublishing, setIsPublishing] = useState(false)
  const PreRequisiteParent = {
    categoryTable: true,
    uploadFile: false
  }
  const PreRequisiteChild = {
    categoryTable: true,
    uploadFile: false
  }
  const [preRequisiteParentTab, setPreRequisiteParentTab] = useState({
    categoryTable: false,
    uploadFile: false
  })
  const [preRequisiteChildTab, setPreRequisiteChildTab] = useState({
    categoryTable: false,
    uploadFile: false
  })
  const productSelections = useAppSelector(state => state.salesTarget.productSelections)

  const [editModeProductIds, setEditModeProductIds] = useState({
    includedIds: [],
    excludedIds: [],
    childExcludedIds: [],
    childIncludedIds: []
  });
  const [salesTargetType, setSalesTargetType] = useState('')

  const getFilteredProducts = (tabType) => {
    if (!productListData?.data || !productListData?.data?.length || isProductListLoading) {
      return []
    }

    let excludedIds = []
    let includedIds = []

    const parentTabData = salesTargetData.tabWiseData?.parent;
    const childTabData = salesTargetData.tabWiseData?.child;

    if (tabType === 'parent') {
      const parentRuleData = parentTabData?.ruleSet?.rules?.[0];
      excludedIds = parentTabData?.excludedProducts || parentRuleData?.excludedProductIds || [];
      includedIds = parentTabData?.includedProducts || parentRuleData?.includedProductIds || [];
    } else if (tabType === 'child') {
      const childRuleData = childTabData?.ruleSet?.rules?.[0];
      excludedIds = childTabData?.excludedProducts || childRuleData?.excludedProductIds || [];
      includedIds = childTabData?.includedProducts || childRuleData?.includedProductIds || [];
    }

    if (excludedIds.length === 0 && includedIds.length === 0) {
      if (id) {
        if (tabType === 'child') {
          excludedIds = editModeProductIds.childExcludedIds || [];
          includedIds = editModeProductIds.childIncludedIds || [];
        } else {
          excludedIds = editModeProductIds.excludedIds || [];
          includedIds = editModeProductIds.includedIds || [];
        }
      }
      else if (productSelections) {
        if (tabType === 'parent') {
          excludedIds = productSelections?.parent?.excluded || []
          includedIds = productSelections?.parent?.included || []
        } else if (tabType === 'child') {
          excludedIds = productSelections?.child?.excluded || []
          includedIds = productSelections?.child?.included || []
        } else {
          excludedIds = productSelections?.all?.excluded || []
          includedIds = productSelections?.all?.included || []
        }
      } else {
        return []
      }
    }

    const relevantProductIds = [...excludedIds, ...includedIds]
    const filteredProducts = productListData.data
      .filter(product => relevantProductIds.includes(product.productId))
      .map(product => ({
        ...product,
        category: product.category_locale || product.category_en,
        brand: product.brand_locale || product.brand_en,
        included: includedIds.includes(product.productId)
      }))

    return filteredProducts
  }

  const [dataList, setListData] = useState({ ...salesTargetData })

  const displayContentLanguages = useAppSelector(state => state.common?.languages || [])
  const languages = COUNTRY_LANGUAGES_CODES[countryCode] || displayContentLanguages || []
  const [activeLanguage, setActiveLanguage] = useState('en')
  const handleTabClick = langCode => {
    setActiveLanguage(langCode)
  }


  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const VALID_STATUSES = ['draft', 'published', 'in progress', 'revoked'];
  const rawStatus = searchParams.get('status');
  const urlStatus = VALID_STATUSES.includes(rawStatus?.toLowerCase()) ? rawStatus : null;
  const disableDraft = location?.state?.disableDraft ?? false
  const editPublishedBeforeStart =
    location?.state?.editPublishedBeforeStart ?? false
  const salesTargetIdFromState = location?.state?.salesTargetId
  const isPrerequisiteTarget =
    salesTargetData?.targetType === TARGET_TYPES.MonthlyTargetPrerequistite ||
    salesTargetData?.targetType === TARGET_TYPES.ProductTargetPrerequisite
  const isLayeredTarget = salesTargetData?.targetType === TARGET_TYPES.ProductTargetLayered || salesTargetData?.targetType === TARGET_TYPES.MonthlyTargetLayered
  const isMainTargetOrProdTarget = salesTargetData?.targetType === TARGET_TYPES.MainTarget || salesTargetData?.targetType === TARGET_TYPES.ProductTarget

  const isEarlyPaymentTarget = useMemo(
    () => salesTargetData?.targetType === TARGET_TYPES.EarlyPaymentTarget,
    [salesTargetData?.targetType]
  )

  const isBoosterPointTarget = useMemo(
    () => salesTargetData?.targetType === TARGET_TYPES.DropSizeTarget,
    [salesTargetData?.targetType]
  )

  const isLinkedTargetType = useMemo(
    () => isEarlyPaymentTarget || isBoosterPointTarget,
    [isEarlyPaymentTarget, isBoosterPointTarget]
  )

  const isRackChallenge = useMemo(
    () => salesTargetData?.targetType === TARGET_TYPES.RackChallenge,
    [salesTargetData?.targetType]
  )

  // isLinkedTargetType and isRackChallenge are mutually exclusive, both skip the Products step
  const isCdaSuperTarget = useMemo(
    () => isCdaSuperTargetType(salesTargetData?.targetType),
    [salesTargetData?.targetType]
  )

  const isThreeStepTarget = useMemo(
    () => isLinkedTargetType || isRackChallenge || isCdaSuperTarget,
    [isLinkedTargetType, isRackChallenge, isCdaSuperTarget]
  )

  const stepConfig = useMemo(
    () => getStepConfig(salesTargetData?.targetType),
    [salesTargetData?.targetType]
  )

  // Dynamic breadcrumb logic
  const breadcrumbs = useMemo(() => {
    const baseBreadcrumbs = [
      { href: ROUTES.HOME, label: '' },
      { href: ROUTES.SALES_TARGETS, label: 'Loyalty Campaigns' }
    ];

    // Check if we have an existing sales target (either from URL id or data id/uuid)
    const hasExistingSalesTarget = !(dataList?.status === null || salesTargetData?.status === null);
    const targetName = dataList?.targetName || salesTargetData?.targetName;

    // Creation flow - no id in URL and no existing data
    if (!hasExistingSalesTarget) {
      return [
        ...baseBreadcrumbs,
        { href: ROUTES.SALES_TARGETS, label: 'Add Sales Target' }
      ];
    }

    // Review/Edit flow - id exists in URL or data has id/uuid
    const displayName = targetName || 'Loading...';
    return [
      ...baseBreadcrumbs,
      { href: ROUTES.SALES_TARGETS, label: 'Sales Target' },
      { href: ROUTES.SALES_TARGETS, label: displayName }
    ];
  }, [id, dataList?.targetName, salesTargetData?.targetName, dataList?.uuid, salesTargetData?.uuid, dataList?.id, salesTargetData?.id]);




  const handlePublishAction = async () => {
    if (isPublishing) return
    setIsPublishing(true)
    try {
      await handlePublish(salesTargetData, isPrerequisiteTarget, categoryList, navigate, ROUTES)
    } finally {
      setIsPublishing(false)
    }
  }

  const handleUpdateInProgressAction = async () => {
    if (isPublishing) return
    setIsPublishing(true)
    try {
      const salesTargetId = salesTargetIdFromState || salesTargetData?.id
      if (!salesTargetId) {
        dispatch(
          setToastNotifications({
            show: true,
            message: 'Sales Target id is missing',
            type: 'error'
          })
        )
        return
      }

      const payload = createSalesTargetRequestObject(
        salesTargetData,
        isPrerequisiteTarget
      )
      payload.status = STATUS_VALUES.Published

      const response = await patchSalesTarget(salesTargetId, payload)
      if (response?.success === false) {
        dispatch(
          setToastNotifications({
            show: true,
            message: response?.message || 'Failed to update sales target',
            type: 'error'
          })
        )
        return
      }

      dispatch(
        setToastNotifications({
          show: true,
          message: 'Sales Target updated',
          type: 'success'
        })
      )
      navigate(ROUTES.SALES_TARGETS)
    } catch {
      dispatch(
        setToastNotifications({
          show: true,
          message: 'Failed to update sales target',
          type: 'error'
        })
      )
    } finally {
      setIsPublishing(false)
    }
  }

  const handleUpdatePublishedAction = async () => {
    if (isPublishing) return
    setIsPublishing(true)
    try {
      const salesTargetId = salesTargetIdFromState || salesTargetData?.id
      if (!salesTargetId) {
        dispatch(
          setToastNotifications({
            show: true,
            message: 'Sales Target id is missing',
            type: 'error'
          })
        )
        return
      }

      const payload = createSalesTargetRequestObject(
        salesTargetData,
        isPrerequisiteTarget
      )
      payload.status = STATUS_VALUES.Published

      const response = await putSalesTarget(salesTargetId, payload)
      if (response?.success === false) {
        dispatch(
          setToastNotifications({
            show: true,
            message: response?.message || 'Failed to update sales target',
            type: 'error'
          })
        )
        return
      }

      dispatch(
        setToastNotifications({
          show: true,
          message: 'Sales Target updated',
          type: 'success'
        })
      )
      navigate(ROUTES.SALES_TARGETS)
    } catch {
      dispatch(
        setToastNotifications({
          show: true,
          message: 'Failed to update sales target',
          type: 'error'
        })
      )
    } finally {
      setIsPublishing(false)
    }
  }
  const handleDraftAction = async () => {
    try {
      if (salesTargetData.targetName === null) {
        dispatch(setToastNotifications({ show: true, message: 'Target Name is required', type: 'error' }))
        return;
      }
      const { salesTargetForDraft } = buildSalesTargetDraftPayload({
        salesTarget: salesTargetData,
        isPrerequisiteTarget,
        fallbackSelectedType: salesTargetData.selectedType,
      });

      await handleDraft(salesTargetForDraft, salesTargetForDraft, isPrerequisiteTarget, 'review', { categoryListData: categoryList })
      navigate(ROUTES.SALES_TARGETS)
    } catch (error) {
      logger.error('Error in handleDraft:', error);
      // Error handling is already done in the hook
    }
  }

  useEffect(() => {
    setListData(prev => deepMerge(prev, salesTargetData));
  }, [productListData, editModeProductIds]);

  const handleCancel = () => {
    setIsCancel(!isCancel)
  }
  // Transforms sales target data into form data structure for editing
  // Handles layered targets, date comparisons, country-specific duration settings,
  // and validation flag initialization
  const createFormData = obj => {

    const isLayeredTarget =
      TARGET_TYPES_OPTIONS[obj?.targetType] === TARGET_TYPES.MonthlyTargetLayered || TARGET_TYPES_OPTIONS[obj?.targetType] === TARGET_TYPES.ProductTargetLayered

    let activeDisplay = false;
    if (obj?.activeStartDate == obj?.displayStartDate &&
      obj?.activeEndDate == obj?.displayEndDate) {
      activeDisplay = true;
    }

    let duration = '';
     const isEgyptAndApplicableTarget = (countryCode === COUNTRY_CODES.EGYPT || countryCode === COUNTRY_CODES.KSA) && (obj?.targetType === TARGET_TYPES.MainTarget || obj?.targetType === TARGET_TYPES.ProductTarget);
    if(isEgyptAndApplicableTarget){
      duration = isEgyptAndApplicableTarget ? 'CUSTOM' : '';
    }

    const formData = {
      targetType: TARGET_TYPES_OPTIONS[obj?.targetType] ?? obj?.targetType,
      targetTypeValue: obj?.targetType,
      targetName: obj?.targetName,
      targetNameValid: false,
      challengeTransactionId: obj?.challengeTransactionId || '',
      challengeTransactionIdValid: obj?.challengeTransactionId ? false : undefined,
      storeList: obj?.storeList,
      ruleSet: obj?.ruleSet,
      awardPointsImmedFlag: obj?.awardPointsImmedFlag,
      pointsDeliveryDate: getDateFromISOString(obj?.pointsDeliveryDate),
      pointsDeliveryDateValid: false,
      targetDeliveryDate: getDateFromISOString(obj?.targetDeliveryDate),
      targetDeliveryDateValid: false,
      startDate: getDateFromISOString(obj?.activeStartDate),
      startDateValid: false,
      activeStartDate: getDateFromISOString(obj?.activeStartDate),
      excludeTaxFromGoal: !obj?.VATIncluded,
      VATIncluded: obj?.VATIncluded,
      offlineOrdersIncluded: obj?.offlineOrdersIncluded,
      joinCampaignFlag: obj?.joinCampaignFlag,
      endDate: getDateFromISOString(obj?.activeEndDate),
      endDateValid: false,
      activeEndDate: getDateFromISOString(obj?.activeEndDate),
      ignoreSkuList: obj?.ignoreSkuList,
      activeDisplay: activeDisplay,
      displayStartDate: getDateFromISOString(obj?.displayStartDate),
      displayStartDateValid: false,
      displayEndDate: getDateFromISOString(obj?.displayEndDate),
      displayEndDateValid: false,
      numberLevel: obj?.metadata?.numberLevel,
      numberMileStone: obj?.metadata?.numberMileStone,
      isNumberOfLevelsSelected: false,
      isNumberOfMilestonesSelected: false,
      roundUpPointsFlag: obj?.roundUpPointsFlag,
      targetMediaFile: obj?.storeList ? [obj?.storeList] : [],
      // this may require in future
      // roundOffValue: obj?.roundPointsValue,
      // roundOffValueValid: obj?.roundPointsValue > 0 ? true : false,
      roundOffValue:  obj?.roundPointsValue > 0? String(obj?.roundPointsValue): '',
      roundOffValueValid: obj?.roundPointsValue > 0 ? false : true,
      pointDisplay: isLayeredTarget ? obj?.pointDisplay : null,
      pointDisplayValid: isLayeredTarget ? false : null,
      duration: duration,
      updatedAt: obj?.updatedAt,
      linkedSalesTargets: obj?.linkedSalesTargetInfo || [],
    }
    return formData
  }

  // this will reset redux salestarget when its draft state
  const getComposedData = async (response) => {
    let composedData = {};
    const responseData  = response?.data?.content[0]?.versionData;
    const displayContentMedia = getDisplayContentMedia(responseData);
    const displayContentMediaOptional = getDisplayContentMediaOptional(responseData);
    let imageUri = null;
    let imageUriOptional = null;
    if (doesImageUrlExists(responseData)) {
      imageUri = responseData?.media[0]?.imageUrl;
    }
    if (doesImageUrlExistsOptional(responseData)) {
      imageUriOptional = responseData?.media[1]?.imageUrl;
    }
    const displayContent = createDisplayContent(responseData);
    const childDisplayContentCopy = responseData?.child ? responseData?.child : {}
    const childDisplayContent = childDisplayContentCopy?.displayContent;
    composedData = {
      ...dataList, formData: createFormData(responseData),
      ...createFormData(responseData),
      ruleSet: responseData?.ruleSet,
      displayContent: {...displayContent,child:childDisplayContent},
      targetName: responseData?.targetName,
      child: {displayContent: childDisplayContent || {} },
      status: responseData?.status,
      pointDisplay: responseData?.pointDisplay,
      joinCampaignFlag: responseData?.joinCampaignFlag,
      id: responseData?.id,
      uuid: responseData?.uuid || null,
      displayContentMedia: responseData?.media?.length > 0 ? {
        ...displayContentMedia,
        title: displayContentMedia?.title,
        imageUrl: displayContentMedia?.imageUrl,
        imageUri: imageUri,
        imageId: normalizeImageId(
          displayContentMedia?.imageId || displayContentMedia?.id || ''
        ),
        optIn: displayContentMedia?.optIn,
      } : {},
      displayContentMediaOptional: responseData?.media?.length > 1 ? {
        ...displayContentMediaOptional,
        title: displayContentMediaOptional?.title,
        imageUrl: displayContentMediaOptional?.imageUrl,
        imageUri: imageUriOptional,
        imageId: normalizeImageId(
          displayContentMediaOptional?.imageId ||
            displayContentMediaOptional?.id ||
            ''
        ),
        optIn: displayContentMediaOptional?.optIn,
      } : {},
      targetType: TARGET_TYPES_OPTIONS[responseData?.targetType],
      targetTypeValue: responseData?.targetType,
      tabWiseData: {
        parent: {
          includedProducts: responseData?.ruleSet?.rules?.[0]?.includedProductIds,
          excludedProducts: responseData?.ruleSet?.rules?.[0]?.excludedProductIds,
          ruleSet: responseData?.ruleSet,
          mediaFile: responseData?.metadata?.isProductIdsUploaded ? [responseData?.metadata?.productFileName] : [],
          selectedCategory: await transformCategories(responseData?.ruleSet),
          ignoreSkuList: responseData?.ignoreSkuList
        },
        child: {
          includedProducts: responseData?.child?.ruleSet?.rules?.[0]?.includedProductIds,
          excludedProducts: responseData?.child?.ruleSet?.rules?.[0]?.excludedProductIds,
          ruleSet: responseData?.child?.ruleSet,
          mediaFile: responseData?.child?.metadata?.isProductIdsUploaded ? [responseData?.child?.metadata?.productFileName] : [],
          selectedCategory: await transformCategories(responseData?.child?.ruleSet),
          ignoreSkuList: responseData?.child?.ignoreSkuList
        }
      },
      media: responseData?.media,
      linkedSalesTargets: responseData?.linkedSalesTargetInfo || [],
      pointsDeliveryDate: responseData?.pointsDeliveryDate || null,
      productGtins: normalizeProductGtins(responseData?.productGtins)
    }
    return {composedData, imageUri}
  }

  // Transforms display content object into standardized format with validation flags
  // Processes all language keys and ensures default validation states
  const createDisplayContent = (obj) => {
    const displayContentObj = obj?.displayContent || {}

    const displayContent = {}

    Object.keys(displayContentObj).forEach((langKey) => {
      displayContent[langKey] = {
        targetType: displayContentObj?.[langKey]?.targetType,
        title: displayContentObj?.[langKey]?.title,
        category: displayContentObj?.[langKey]?.category,
        parentCategory: displayContentObj?.[langKey]?.parentCategory,
        childCategory: displayContentObj?.[langKey]?.childCategory,
        excerpt: displayContentObj?.[langKey]?.excerpt,
        terms: displayContentObj?.[langKey]?.terms,
        description: displayContentObj?.[langKey]?.description,
        pointsEarned: displayContentObj?.[langKey]?.pointsEarned,
        titleValid: displayContentObj?.[langKey]?.titleValid ?? false,
        excerptValid: displayContentObj?.[langKey]?.excerptValid ?? false,
        termsValid: displayContentObj?.[langKey]?.termsValid ?? false,
        descriptionValid: displayContentObj?.[langKey]?.descriptionValid ?? false,
        pointsEarnedValid: displayContentObj?.[langKey]?.pointsEarnedValid ?? false,
      }
    })
    return displayContent
  }

  // Normalizes image ID values to match IMAGETYPE constants
  // Converts string 'Foreground'/'Background' to their enum values
  const normalizeImageId = (value) => {
    if (value === 'Foreground') return IMAGETYPE.Foreground;
    if (value === 'Background') return IMAGETYPE.Background;
    return value;
  };

  // Transforms category IDs from ruleSet into category objects with display text
  // Fetches full category list and filters by included category IDs
  const transformCategories = async(ruleSet) => {
    if (
      !ruleSet?.rules?.[0]?.includedCategories
    ) {
      return [];
    }
    const includedCategoryIds = ruleSet.rules[0].includedCategories;
    if(includedCategoryIds.length>0){
      const categoryList = await fetchCategoryList();
        const cats = categoryList
          .filter(cat => includedCategoryIds.includes(cat.category))
          .map(cat => ({
            ...cat,
            displayText: cat.category
          }));
          return cats
      }
      return []
  };

  let changeParam = id

  // Determines query parameter name based on URL status
  // Returns 'uuid' for draft status, 'id' for all other statuses
  const getParam = (urlStatus)=>{
   return  urlStatus?.toLowerCase() === API_STATUS.DRAFT?.toLowerCase() ? 'uuid' : 'id';
  }

  // Validates API response structure
  // Returns true if response has data in either root array or content array
  const validResonse = (response) => {
    return response.data.length > 0 || response?.data?.content?.length > 0
  }

  // Extracts product upload flag from response metadata
  // Returns the isProductIdsUploaded flag from the first data item
  const getProductUploadedFlag = (response) => {
    return  response?.data?.[0]?.metadata?.isProductIdsUploaded
  }

  // Checks if draft response contains prerequisite target type
  // Returns true for Monthly or Product Prerequisite targets in draft version data
  const checkDraftPreRequisite = (response) => {
   return (response?.data?.content?.[0]?.versionData?.targetType == 'Monthly Prerequisite Target' || response?.data?.content?.[0]?.versionData?.targetType == 'Product Prerequisite Target')
  }

  // Checks if published response contains prerequisite target type
  // Returns true for Monthly or Product Prerequisite targets in published data
  const checkPreRequisite = (response) => {
    return (response?.data?.[0]?.targetType == 'Monthly Prerequisite Target' || response?.data?.[0]?.targetType == 'Product Prerequisite Target')
  }

  // Checks if primary image URL exists in media array
  // Returns the imageUrl string or undefined if not present
  const doesImageUrlExists = (responseData)=>{
    return responseData?.media?.[0]?.imageUrl
  }

  // Extracts primary media object from media array
  // Returns first media item or empty object if media array is missing
  const getDisplayContentMedia = (responseData) => {
    return responseData?.media?.[0] || {};
  }

  // Extracts optional (second) media object from media array
  // Returns second media item or empty object if not available
  const getDisplayContentMediaOptional = (responseData) => {
    return responseData?.media?.[1] || {};
  }

  // Checks if optional (second) image URL exists in media array
  // Returns the imageUrl string or undefined if not present
  const doesImageUrlExistsOptional = (responseData) => {
    return responseData?.media?.[1]?.imageUrl;
  }
  // this will reset redux salestarget when its published state
  const getPublishedComposedData = async (response, formData, dataList, displayContent, childDisplayContent, imageUri) => {
    const responseData = response?.data?.[0];
    const displayContentMedia = getDisplayContentMedia(responseData);
    const displayContentMediaOptional = getDisplayContentMediaOptional(responseData);
    let imageUriOptional = null;
    if (doesImageUrlExistsOptional(responseData)) {
      imageUriOptional = responseData?.media[1]?.imageUrl;
    }
    return {
      ...dataList,
      formData: formData,
      ...formData,
      ruleSet: responseData?.ruleSet,
      displayContent: {...displayContent,child:childDisplayContent},
      targetName: responseData?.targetName,
      child: { displayContent: childDisplayContent },
      status: responseData?.status,
      pointDisplay: responseData?.pointDisplay,
      joinCampaignFlag: responseData?.joinCampaignFlag,
      id: responseData?.id,
      uuid: responseData?.uuid || null,
      displayContentMedia: {
        ...displayContentMedia,
        title: displayContentMedia?.title,
        imageUrl: displayContentMedia?.imageUrl,
        imageUri: imageUri,
        imageId: normalizeImageId(
          displayContentMedia?.imageId || displayContentMedia?.id || ''
        ),
      },
      displayContentMediaOptional: responseData?.media?.length > 1 ? {
        ...displayContentMediaOptional,
        title: displayContentMediaOptional?.title,
        imageUrl: displayContentMediaOptional?.imageUrl,
        imageUri: imageUriOptional,
        imageId: normalizeImageId(
          displayContentMediaOptional?.imageId ||
            displayContentMediaOptional?.id ||
            ''
        ),
      } : {},
      targetType: TARGET_TYPES_OPTIONS[responseData?.targetType],
      targetTypeValue: responseData?.targetType,
      tabWiseData: {
        parent: {
          includedProducts: responseData?.ruleSet?.rules?.[0]?.includedProductIds,
          excludedProducts: responseData?.ruleSet?.rules?.[0]?.excludedProductIds,
          ruleSet: responseData?.ruleSet,
          mediaFile: responseData?.metadata?.isProductIdsUploaded ? [responseData?.metadata?.productFileName] : [],
          selectedCategory:  await transformCategories(responseData?.ruleSet),
          ignoreSkuList: responseData?.ignoreSkuList
        },
        child: {
          includedProducts: responseData?.children?.[0]?.ruleSet?.rules?.[0]?.includedProductIds,
          excludedProducts: responseData?.children?.[0]?.ruleSet?.rules?.[0]?.excludedProductIds,
          ruleSet: responseData?.children?.[0]?.ruleSet,
          mediaFile: responseData?.children?.[0]?.metadata?.isProductIdsUploaded ? [responseData?.children?.[0]?.metadata?.productFileName] : [],
          selectedCategory:  await transformCategories(responseData?.children?.[0]?.ruleSet),
          ignoreSkuList: responseData?.children?.[0]?.ignoreSkuList
        }
      },
      awardPointsImmedFlag:responseData?.awardPointsImmedFlag,
      media: responseData?.media,
      linkedSalesTargets: responseData?.linkedSalesTargetInfo || [],
      pointsDeliveryDate: responseData?.pointsDeliveryDate || null,
      productGtins: normalizeProductGtins(responseData?.productGtins)
    }
  }
  // let [loading, setLoading] = useState(false)
  const getSalesDataById = useCallback(
    async id => {
      try {
        changeParam = getParam(urlStatus);
        setLoading(true)
        const response = await getSalesTargetData(`${changeParam}=${id}`);
        setLoading(false)
        let imageUri = null;

        let parentRulesObj = null;
        let childRulesObj = null;
        let responseData;
        if (validResonse(response)) {
          let composedData = {};
          if (urlStatus?.toLowerCase() === API_STATUS.DRAFT?.toLowerCase()) {
            responseData  = response?.data?.content[0]?.versionData;
            const d  = await getComposedData(response);
            composedData = d.composedData;
            dispatch(setSalesTarget(composedData))
            dispatch(setSalesTargetUuid(composedData.uuid))

            // Determine upload flags from draft metadata
            const parentUploadedDraft = !!responseData?.metadata?.isProductIdsUploaded;
            const childUploadedDraft =
              checkDraftPreRequisite(response) && !!responseData?.child?.metadata?.isProductIdsUploaded;

            const parentTabStateDraft = parentUploadedDraft
              ? { categoryTable: false, uploadFile: true }
              : { categoryTable: true, uploadFile: false };
            const childTabStateDraft = childUploadedDraft
              ? { categoryTable: false, uploadFile: true }
              : { categoryTable: true, uploadFile: false };

            // Selected type at review level is still driven by parent upload flag
            dispatch(setSelectedType(parentUploadedDraft ? Constants?.UploadedProducts : Constants?.CategoryProducts));

            setPreRequisiteParentTab(parentTabStateDraft);
            setPreRequisiteChildTab(childTabStateDraft);
            dispatch(addPreRequisiteParentTab(parentTabStateDraft));
            dispatch(addPreRequisiteChildTab(childTabStateDraft));

          } else {
            responseData = response?.data?.[0]
              if(doesImageUrlExists(responseData)) {
              imageUri = responseData?.media[0]?.imageUrl;
            }
            const formData = createFormData(responseData);
            const displayContent = createDisplayContent(responseData);
            const childDisplayContent = createDisplayContent(responseData?.children?.[0] || {});
            setSalesTargetType(responseData.targetType);
            composedData = await getPublishedComposedData(response, formData, dataList,displayContent, childDisplayContent, imageUri)
            dispatch(setSalesTarget(composedData))
            dispatch(setSalesTargetUuid(composedData.uuid))
            if (getProductUploadedFlag(response)) {
              dispatch(setSelectedType(Constants?.UploadedProducts));
              setPreRequisiteParentTab({
                categoryTable: false,
                uploadFile: true
              });
            } else {
              dispatch(setSelectedType(Constants?.CategoryProducts));
              setPreRequisiteParentTab({
                categoryTable: true,
                uploadFile: false
              });
            }

            if (checkPreRequisite(response) && responseData?.children?.[0]?.metadata?.isProductIdsUploaded) {
              setPreRequisiteChildTab({
                categoryTable: false,
                uploadFile: true
              });
            } else {
              setPreRequisiteChildTab({
                categoryTable: true,
                uploadFile: false
              });
            }
          }

          if (urlStatus?.toLowerCase() === API_STATUS.DRAFT?.toLowerCase()) {
            parentRulesObj = responseData?.ruleSet?.rules?.[0];
          } else {
            parentRulesObj = response?.data[0]?.ruleSet?.rules?.[0];
          }

          if (urlStatus?.toLowerCase() === API_STATUS.DRAFT?.toLowerCase()) {
            if (responseData?.child?.ruleSet?.rules?.[0]) {
              childRulesObj = responseData?.child?.ruleSet?.rules?.[0];
            }
          } else {
            if (response?.data[0]?.children && response?.data[0]?.children.length > 0) {
              childRulesObj = response?.data[0]?.children?.[0]?.ruleSet?.rules?.[0];
            }
          }

          // Extract parent and child product IDs
          const parentIncludedIds = parentRulesObj?.includedProductIds || [];
          const parentExcludedIds = parentRulesObj?.excludedProductIds || [];

          const childIncludedIds = childRulesObj?.includedProductIds || [];
          const childExcludedIds = childRulesObj?.excludedProductIds || [];
          const childAllProductIds = [...childIncludedIds, ...childExcludedIds];

          setEditModeProductIds({
            includedIds: parentIncludedIds,
            excludedIds: parentExcludedIds,
            childIncludedIds: childIncludedIds,
            childExcludedIds: childExcludedIds
          });

          const combinedIncludedIds = childAllProductIds.length > 0 ?
            [...parentIncludedIds, ...childIncludedIds] :
            parentIncludedIds;

          const combinedExcludedIds = childAllProductIds.length > 0 ?
            [...parentExcludedIds, ...childExcludedIds] :
            parentExcludedIds;

          // Create a single rule set with combined product IDs
          const updatedRuleSet = {
            includeAllProductsByDefault: parentRulesObj?.includeAllProductsByDefault || false,
            skipNonAssorted: false,
            rules: [
              {
                includedCategories: parentRulesObj?.includedCategories || [],
                includedProductIds: combinedIncludedIds,
                excludedCategories: parentRulesObj?.excludedCategories || [],
                excludedProductIds: combinedExcludedIds
              }
            ]
          };

          dispatch(setRuleSet({ ruleSet: updatedRuleSet }));
          dispatch(setInitialTargetName(composedData.targetName))
          setListData(composedData)
          dispatch(setTargetType(composedData.targetType))
          dispatch(
            setToastNotifications({ show: true, message: ' Sales Target data fetched succesfully', type: 'success' })
          )
        } else dispatch(setToastNotifications({ show: true, message: 'Sales Target data not fetched', type: 'error' }))
      } catch (err) {
        setLoading(false)
        logger.error(err)
        handleApiError(err)
      }
    },
    [dataList, dispatch]
  )

  const handleTemplateUpdateAndRefetch = useCallback(
    async (salesTargetId, fileUrl) => {
      const isSuccess = await onTemplateUpdate(salesTargetId, fileUrl)
      if (isSuccess && salesTargetId) {
        await getSalesDataById(salesTargetId)
      }
      return isSuccess
    },
    [getSalesDataById, onTemplateUpdate]
  )
  useEffect(() => {
   ( async()=>{
    const data = await fetchCategoryList();
    setCategoryList(data);
    })()
  }, [])

  useEffect(() => {
    if (id) {
      getSalesDataById(id)
      setIsReadOnly(true)
      // get language
      getDisplayContentLanguagesService().then(res => {
        dispatch(setLanguages(res))
      })
    }
  }, [id])

  useEffect(() => {
    if (id && productListData?.data?.length) {
      let dataWithIncluded = productListData.data.map(product => ({ ...product }))
      dispatch(setSalesTargetFormData({ selectedSalesTargetProduct: dataWithIncluded }))
    }
  }, [id, productListData])

  const onClickPrimaryButton = () => {
    dispatch(resetSalesTarget())
    navigate(ROUTES.SALES_TARGETS)
  }

  const onClickSecondaryButton = () => {
    setIsCancel(!isCancel)
  }

  //Handle duplicate sales target action
  const handleDuplicate = (route) => {

    if (dataList.formData) {
      const updatedDataList = JSON.parse(JSON.stringify(dataList));
      // Set status to null so when user come back to review page they get the edit option
      updatedDataList.status = null;

      // Reset target name
      updatedDataList.formData.targetName = null;
      updatedDataList.formData.targetNameValid = true;
      updatedDataList.formData.awardPointsImmedFlag = updatedDataList.awardPointsImmedFlag;

      // Reset active display
      if (updatedDataList.formData.startDate == updatedDataList.formData.displayStartDate &&
        updatedDataList.formData.endDate == updatedDataList.formData.displayEndDate) {
        updatedDataList.formData.activeDisplay = true;
      }

      // Reset award point
      // updatedDataList.formData.awardPointsImmedFlag = updatedDataList.formData.targetDeliveryDate == updatedDataList.formData.pointsDeliveryDate;

      // Reset validation flags
      updatedDataList.formData.startDateValid = false;
      updatedDataList.formData.endDateValid = false;
      updatedDataList.formData.displayStartDateValid = false;
      updatedDataList.formData.displayEndDateValid = false;
      updatedDataList.formData.targetDeliveryDateValid = false;
      updatedDataList.formData.pointsDeliveryDateValid = false;

      // Reset selection flags
      updatedDataList.formData.isNumberOfLevelsSelected = false;
      updatedDataList.formData.isNumberOfMilestonesSelected = false;

      // Reset dates if start date is in the past
      if (new Date(updatedDataList.formData.startDate) <= new Date()) {
        updatedDataList.formData.displayStartDate = null;
        updatedDataList.formData.displayEndDate = null;
        updatedDataList.formData.startDate = null;
        updatedDataList.formData.endDate = null;
        updatedDataList.formData.targetDeliveryDate = null;
        updatedDataList.formData.pointsDeliveryDate = null;

        updatedDataList.formData.startDateValid = undefined;
        updatedDataList.formData.endDateValid = undefined;
        updatedDataList.formData.displayStartDateValid = undefined;
        updatedDataList.formData.displayEndDateValid = undefined;
        updatedDataList.formData.targetDeliveryDateValid = undefined;
        updatedDataList.formData.pointsDeliveryDateValid = undefined;
      }

      // Restore Target CSV File
      updatedDataList.storeList = updatedDataList.formData.storeList;
      updatedDataList.formData.targetMediaFile = [updatedDataList.storeList];

      // Dispatch the updated state to Redux
      dispatch(setSalesTarget(updatedDataList));
      navigate(route, { state: { isEdit: true } });
    } else {
      navigate(route, { state: { isEdit: true } });
    }
  }

  const editDraftEntries = (route) => {
    if (dataList.formData && urlStatus === Constants?.Draft) {
      const updatedDataList = JSON.parse(JSON.stringify(dataList));
      updatedDataList.formData.targetName = updatedDataList.targetName;
      updatedDataList.formData.targetNameValid = false;

      const validateValue = (value, setter) => {
        if (value && typeof value !== 'undefined' && value !== '') {
          setter(false);
        } else {
          setter(undefined);
        }
      };
      validateValue(updatedDataList.formData.startDate, (value) => (updatedDataList.formData.startDateValid = value));
      validateValue(updatedDataList.formData.endDate, (value) => (updatedDataList.formData.endDateValid = value));
      validateValue(updatedDataList.formData.displayStartDate, (value) => (updatedDataList.formData.displayStartDateValid = value));
      validateValue(updatedDataList.formData.displayEndDate, (value) => (updatedDataList.formData.displayEndDateValid = value));
      validateValue(updatedDataList.formData.targetDeliveryDate, (value) => (updatedDataList.formData.targetDeliveryDateValid = value));
      validateValue(updatedDataList.formData.pointsDeliveryDate, (value) => (updatedDataList.formData.pointsDeliveryDateValid = value));

      updatedDataList.formData.isNumberOfLevelsSelected = false;
      updatedDataList.formData.isNumberOfMilestonesSelected = false;
      updatedDataList.storeList = updatedDataList.formData.storeList;
      updatedDataList.formData.targetMediaFile = [updatedDataList.storeList];
      updatedDataList.initialTargetName = salesTargetData.initialTargetName;
      updatedDataList.uuid = salesTargetData.uuid; // Preserve UUID
      // Preserve prerequisite tab configuration (category vs upload file) for Products page
      updatedDataList.preRequisiteParentTab = salesTargetData.preRequisiteParentTab;
      updatedDataList.preRequisiteChildTab = salesTargetData.preRequisiteChildTab;
      dispatch(setSalesTarget(updatedDataList))
      navigate(route, { state: { isEdit: true } })
    } else {
      navigate(route,{ state: { isEdit: true } })
    }
  }
  const handleDownload = async () => {
    if (!id || urlStatus?.toLowerCase() === API_STATUS.DRAFT?.toLowerCase()) return;
    try {
      const data = await getSalesTargetsReporteDownload(`salesTargetId=${id}`);
      const dateStr = getDateWithTimeString();
      const type = salesTargetData?.targetType;
      let fileName = `SalesTarget_Report${dateStr}`;
      if (isEarlyPaymentTarget || EARLY_PAYMENT_TYPES.includes(type)) {
        fileName = `EarlyPayment_Invoice_Report${dateStr}`;
      } else if (isBoosterPointTarget || DROP_SIZE_TYPES.includes(type)) {
        fileName = `DropSizePoint_Invoice_Report${dateStr}`;
      }
      downloadCSVFiles(data, fileName);
    } catch (error) {
      dispatch(setToastNotifications({ show: true, message: 'Failed to download report', type: 'error' }));
      handleApiError(error);
    }
  };

  const editPanel = (route) => {
    editDraftEntries(route);
  }
  const handleSetActiveTab = () => {
    dispatch(setPageActiveTab({ activeTab: 'parent', pageTitle: 'Products' }));
  }

  const canEditPublishedBeforeStart = useMemo(() => {
    if (disableDraft && editPublishedBeforeStart) return true
    if (!id) return false
    if (urlStatus?.toLowerCase() !== API_STATUS.PUBLISHED?.toLowerCase() && urlStatus?.toLowerCase() !== Constants.Published?.toLowerCase()) {
      return false
    }
    const startDate = dataList?.formData?.startDate
    if (!startDate) return false
    const start = new Date(startDate)
    if (Number.isNaN(start.getTime())) return false
    return new Date() < start
  }, [disableDraft, editPublishedBeforeStart, id, urlStatus, dataList?.formData?.startDate])

  const handleStepClick = (step) => {
    const stepState = {
      isEdit: true,
      disableDraft,
      editPublishedBeforeStart,
      salesTargetId: salesTargetIdFromState || salesTargetData?.id
    }


    if (step === 1) navigate(ROUTES.SALES_TARGET_ADD, {state: stepState});
    if (step === 2)
      navigate(
        isRackChallenge
          ? ROUTES.RACK_CHALLENGE_DISPLAY_CONTENT
          : ROUTES.SALES_TARGET_DISPLAY_CONTENT,
        {state: stepState}
      );
    if (!isThreeStepTarget && step === 3)
      navigate(ROUTES.SALES_TARGET_PRODUCTS, {state: stepState});
  }

  return (
    <ErrorBoundary>
      <>
        <Breadcrumb
        uiSchema={{
          isDark: true,
          className: 'mb-5',
          breadcrumbs: breadcrumbs,
        }}
        id={'str_bradcrumb'}
      />
      <PageHeader title={isReadOnly ? `Sales Target ${countryName}` : 'Add Sales Target'} />
      <>
        {!isReadOnly && (
          <ProgressIndicator
            currentStep={stepConfig.steps}
            completed={false}
            steps={stepConfig.steps}
            titles={stepConfig.titles}
            className="mb-6"
            onStepClick={handleStepClick}
          />
        )}
        {isReadOnly && (
          <ReviewActionHeader
            date={getSalesTargetDate(dataList, urlStatus)}
            onDuplicate={handleDuplicate}
            onDownload={handleDownload}
            isDuplicateEnabled={urlStatus?.toLowerCase() !== API_STATUS.DRAFT?.toLowerCase()}
            showDuplicateButton={!isLinkedTargetType}
            hideActions={isRackChallenge}
          />
        )}
        <br />

      {loading ?
        <TableSkeletonLoader rows={10} rowHeight={30} spacing={20} />
        :
        <ReviewAccordion
          salesTargetData={dataList}
          isOpenStoreListModal={isOpenStoreListModal}
          setOpenStoreListModal={setOpenStoreListModal}
          languages={languages}
          handleTabClick={handleTabClick}
          activeLanguage={activeLanguage}
          editPanel={editPanel}
          status={dataList?.status}
          canEditPublishedBeforeStart={canEditPublishedBeforeStart}
          preRequisiteParentTab={preRequisiteParentTab}
          preRequisiteChildTab={preRequisiteChildTab}
          handleSetActiveTab={handleSetActiveTab}
          getFilteredProducts={getFilteredProducts}
          onTemplateUpdate={handleTemplateUpdateAndRefetch}
          salesTargetId={id}
        />
      }

        {isCancel ? (
          <Modal
            type={MODAL_TYPE.FLUID}
            showModal={isCancel}
            onCloseModal={handleCancel}
            title="Are you sure you want to cancel?"
            text={'Your work will not be saved if you click Yes. To continue editing and go back to the page, click NO'}
            showPrimaryButton={true}
            primaryButtonText="Yes"
            onClickPrimaryButton={onClickPrimaryButton}
            showSecondaryButton={true}
            secondaryButtonText="No"
            onClickSecondaryButton={onClickSecondaryButton}
            footerProps={{
              size: 'medium',
              type: 'primary',
            }}
            isDark={true}
          />
        ) : null}
        {!id ? (
          <SaveCancelFooter
            isReview={true}
            handleCancel={handleCancel}
            draftAction={handleDraftAction}
            nextAction={salesTargetData?.status && salesTargetData.status.toLowerCase() === Constants.InProgress.toLowerCase() ? handleUpdateInProgressAction : disableDraft ? handleUpdatePublishedAction : handlePublishAction}
            nextButtonTitle={disableDraft ? 'Submit' : undefined}
            FormError={isPublishing}
            disableDraft={disableDraft}
          />
        ) : null}
        </>
      </>
    </ErrorBoundary>
  )
}
